import React, { useState, useEffect } from 'react';
import { Toast } from 'primereact/toast';
import { SortOrder } from 'primereact/api';
import { useBranchOffices } from '../hooks/useBranchOffices';
import { TableWithHeader, TableColumn } from '../../common';
import { BranchOffice } from '../types/branch-office.types';

const BranchOfficeScreen: React.FC = () => {
  const {
    branchOffices,
    isLoading,
    error,
    fetchBranchOffices,
    clearError,
  } = useBranchOffices();

  const [globalFilterValue, setGlobalFilterValue] = useState('');
  const [sortField, setSortField] = useState<keyof BranchOffice>('name');
  const [sortOrder, setSortOrder] = useState<SortOrder>(1);
  const [toast, setToast] = useState<Toast | null>(null);

  useEffect(() => {
    fetchBranchOffices();
  }, [fetchBranchOffices]);

  useEffect(() => {
    if (error) {
      toast?.show({
        severity: 'error',
        summary: 'Error',
        detail: error,
        life: 3000,
      });
      clearError();
    }
  }, [error, toast, clearError]);

  const columns: TableColumn<BranchOffice>[] = [
    {
      field: 'id',
      header: 'ID',
      sortable: true,
      minWidth: '80px',
    },
    {
      field: 'name',
      header: 'Nombre',
      sortable: true,
      minWidth: '200px',
    },
    {
      field: 'address',
      header: 'Dirección',
      sortable: true,
      minWidth: '250px',
    },
    {
      field: 'region',
      header: 'Región',
      sortable: true,
      minWidth: '150px',
    },
    {
      field: 'chain',
      header: 'Cadena',
      sortable: true,
      minWidth: '150px',
    },
  ];

  return (
    <div className="space-y-6">
      <Toast ref={setToast} />
      
      <TableWithHeader
        data={branchOffices}
        columns={columns}
        loading={isLoading}
        header={{
          title: 'Sucursales',
          subtitle: 'Ver todas las sucursales en el sistema',
        }}
        globalFilterValue={globalFilterValue}
        onGlobalFilterChange={setGlobalFilterValue}
        globalFilterPlaceholder="Buscar sucursales..."
        globalFilterFields={['id', 'name', 'address', 'region', 'chain']}
        sortField={sortField}
        sortOrder={sortOrder}
        onSort={(field, order) => {
          setSortField(field);
          setSortOrder(order);
        }}
        emptyMessage="No se encontraron sucursales"
      />
    </div>
  );
};

export default BranchOfficeScreen; 